import React from "react";
import { motion } from "framer-motion";
import { processData } from "../Data";

const ProcessSection = ({desc="", heading=""}) => {

  // PREMIUM FADE UP
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // CARD ANIMATION
  const cardVariant = {
    hidden: {
      opacity: 0,
      y: 55,
      scale: 0.96,
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        delay: i * 0.12,
        duration: 0.85,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

  return (
    <>
      <section className="process-section">

        <div className="container">

          {/* TOP */}

          <motion.div
            className="services-top"
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.2,
            }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.15,
                },
              },
            }}
          >

            <motion.h2
              className="section-heading center-heading"
              variants={fadeUp}
            >
              {heading || (
              <>How we make <span> It easy for you ?</span></>
               )}
            </motion.h2>

            <motion.div
              className="heading-line"
              initial={{
                width: 0,
                opacity: 0,
              }}
              whileInView={{
                width: "120px",
                opacity: 1,
              }}
              transition={{
                duration: 1,
                ease: [0.22, 1, 0.36, 1],
              }}
              viewport={{
                once: true,
              }}
            />

            <motion.p
              className="section-text center-text"
              variants={fadeUp}
            >
            {desc ||  "We stream-line the entire process with clear communication, upfront pricing, and a dedicated local expert handling all the legal heavy lifting for you from start to finish." }
            </motion.p>

          </motion.div>

          {/* PROCESS GRID */}

          <motion.div
            className="process-grid"
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.12,
            }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.12,
                },
              },
            }}
          >

            {processData.map((item, i) => (

              <motion.div
                className="process-card"
                key={i}
                custom={i}
                variants={cardVariant}
                whileHover={{
                  y: -6,
                }}
                transition={{
                  duration: 0.3,
                }}
              >

                {/* CONNECTING LINE */}

                {i !== processData.length - 1 && (

                  <motion.div
                    className="process-line"
                    initial={{
                      scaleX: 0,
                      opacity: 0,
                    }}
                    whileInView={{
                      scaleX: 1,
                      opacity: 1,
                    }}
                    transition={{
                      delay: i * 0.18,
                      duration: 0.8,
                      ease: [0.22, 1, 0.36, 1],
                    }}
                    viewport={{
                      once: true,
                    }}
                    style={{
                      originX: 0,
                    }}
                  />

                )}

                {/* ICON */}

                <motion.div
                  className="process-icon-wrap"
                >

                  <img
                    src={item.icon}
                    alt={`${item.title} | LDL Settlement Services`}
                  />

                </motion.div>

                <h3 className="card-heading">
                  {item.title}
                </h3>

                <p className="section-text">
                  {item.desc}
                </p>

              </motion.div>

            ))}

          </motion.div>

        </div>
      </section>
    </>
  );
};

export default ProcessSection;